import { useEffect } from "react";
import { useParams, useLocation, Link } from "react-router";
import { GamgeeChatSession } from "~/stores/slices/chat-sessions";
import { useGlobalStore } from "~/stores/store-provider";
import PopOver from "./popover";

type SessionData = {
  sessionId: string | null;
  sessionTitle: string | null;
};

const ProjectList = ({
  setActiveRenameModalHandler,
  setActiveDeleteModalHandler,
  setRenameModalPropsHandler,
}: {
  setActiveRenameModalHandler: (prop: boolean) => void;
  setActiveDeleteModalHandler: (prop: boolean) => void;
  setRenameModalPropsHandler: (prop: SessionData) => void;
}) => {
  const {
    chatSessions,
    fetchChatSessions,
    setSessionDocumentView,
    clearChatMessages,
    resetAnalysisDocument,
  } = useGlobalStore((state) => state);
  const params = useParams();
  const location = useLocation();
  const pathname = location.pathname;
  const currentSessionId = (params?.sessionId as string) || "";

  useEffect(() => {
    fetchChatSessions();
  }, []);

  const onSessionClick = (e: React.MouseEvent<HTMLAnchorElement>, session: GamgeeChatSession) => {
    // Always clear state for any session navigation
    clearChatMessages();
    resetAnalysisDocument();
    setSessionDocumentView(false);
    
    // Check if we need hard refresh (technical to technical navigation)
    const isCurrentTechnical = pathname.includes('/session/technical/');
    const isTargetTechnical = session.session_type === 'technical';
    
    if (isCurrentTechnical && isTargetTechnical) {
      // Hard refresh for Marimo notebook navigation
      e.preventDefault();
      window.location.href = e.currentTarget.href;
    }
    // Otherwise, let Link handle normal Next.js navigation
  }

  return (
    <div className="w-full h-full">
      <h2 className="text-base-content/70 p-4">Projects</h2>
      <ul className="menu p-0 w-full h-full overflow-y-auto block">
        {chatSessions.map((session: GamgeeChatSession, index: number) => (
          <li
            key={index}
            className={"w-full @container group"}
            title={session.title}
          >
            <div
              className={`flex items-center justify-between w-full ${
                session.session_id === currentSessionId ? "menu-active" : ""
              }`}
            >
              <Link
                to={`/session/${session.session_type}/${session.session_id}`}
                className="block truncate flex-1 w-4/5"
                onClick={(e) => onSessionClick(e, session)}
              >
                {session.title}
              </Link>
              <div className="hidden group-hover:block">
                <PopOver
                  sessionId={session.session_id}
                  sessionTitle={session.title}
                  showMoreButton={true}
                  setActiveRenameModalHandler={setActiveRenameModalHandler}
                  setActiveDeleteModalHandler={setActiveDeleteModalHandler}
                  setRenameModalPropsHandler={setRenameModalPropsHandler}
                />
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ProjectList;
